module.exports = __webpack_public_path__ + "img/博物馆的力量.4174bc6a.png";